"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get getConcurrency () {
        return _getConcurrency.getConcurrency;
    },
    get getConfig () {
        return _getConfig.getConfig;
    },
    get getMaxWorkersPerTask () {
        return _getMaxWorkersPerTask.getMaxWorkersPerTask;
    },
    get getMaxWorkersPerTaskFromOptions () {
        return _getMaxWorkersPerTask.getMaxWorkersPerTaskFromOptions;
    },
    get readConfigFile () {
        return _readConfigFile.readConfigFile;
    }
});
const _getConfig = require("./getConfig.js");
const _getConcurrency = require("./getConcurrency.js");
const _getMaxWorkersPerTask = require("./getMaxWorkersPerTask.js");
const _readConfigFile = require("./readConfigFile.js");
